/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type NavbarDropdown_user$ref = any;
export type NavbarDropdown_user = {
    readonly firstName: string | null;
    readonly role: string | null;
    readonly conciergeUser: ({
        readonly id: string;
    }) | null;
    readonly profile: ({
        readonly id: string;
        readonly image: string | null;
    }) | null;
    readonly permissions: ({
        readonly id: string;
        readonly oneCommerce: ({
            readonly id: string;
            readonly superAdmin: ({
                readonly access: boolean | null;
            }) | null;
            readonly ceo: ({
                readonly access: boolean | null;
            }) | null;
        }) | null;
    }) | null;
    readonly pointBalance: number | null;
    readonly " $refType": NavbarDropdown_user$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "access",
            "args": null,
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Fragment",
        "name": "NavbarDropdown_user",
        "type": "User",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "firstName",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "role",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "conciergeUser",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": false,
                "selections": [
                    (v0 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "profile",
                "storageKey": null,
                "args": null,
                "concreteType": "Profile",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "image",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "permissions",
                "storageKey": null,
                "args": null,
                "concreteType": "PermissionsType",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "oneCommerce",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "OneCommerceType",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "superAdmin",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "AccessType",
                                "plural": false,
                                "selections": (v1 /*: any*/)
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "ceo",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "AccessType",
                                "plural": false,
                                "selections": (v1 /*: any*/)
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "pointBalance",
                "args": null,
                "storageKey": null
            }
        ]
    } as any;
})();
(node as any).hash = '5dc528c1acadca755fb0bba436304199';
export default node;
